import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=5bc4b7ae&"
import script from "./Statements.vue?vue&type=script&lang=js&"
export * from "./Statements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports